import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { IStudentInfo, IStudentUpdate } from '../models/student';
import { ErrorService } from '../helpers/errorService';

@Injectable({
  providedIn: 'root'
})
export class StudentService {
  constructor(
      private http: HttpClient,
      private errorService: ErrorService
  ) { }

  findStudentBySsid(regionId: string, data: {building_id: string, student_identifier: string}): Observable<any> {
    const url = environment.apiBaseUrl + endpoints.findStudentBySsid.replace(':regionId', regionId);
    return this.http.post(url, data).pipe(
      catchError(this.errorService.handleError)
    );
  }
  
  // create new student and new case for that student
  createStudent(regionId: string, studentData: Array<IStudentInfo>): Observable<any> {
    const url = environment.apiBaseUrl + endpoints.createStudent.replace(':regionId', regionId);
    return this.http.post(url, studentData).pipe(
      catchError(this.errorService.handleSavingError)
    );
  }

  updateStudent(regionId: string, updateData: Array<IStudentUpdate>): Observable<any> {
    const url = environment.apiBaseUrl + endpoints.updateStudent.replace(':regionId', regionId);
    return this.http.post(url, updateData).pipe(
      catchError(this.errorService.handleSavingError)
    );
  }

}